/* Golden Empress — Theme JS */

// FAQ Toggle
function geoToggle(btn) {
  const item = btn.parentElement;
  item.classList.toggle('open');
}

// Shop filter
function filterProducts(btn, tag) {
  // Update active button
  document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');

  // Filter cards
  const cards = document.querySelectorAll('#product-grid .product-card');
  cards.forEach(card => {
    if (tag === 'all') {
      card.style.display = 'block';
    } else {
      const tags = card.dataset.tags || '';
      card.style.display = tags.includes(tag) ? 'block' : 'none';
    }
  });
}

// Scroll-based nav shadow
window.addEventListener('scroll', () => {
  const nav = document.querySelector('.site-nav');
  if (nav) {
    if (window.scrollY > 20) {
      nav.style.boxShadow = '0 4px 30px rgba(60,26,75,0.12)';
    } else {
      nav.style.boxShadow = 'none';
    }
  }
});
